import { render, staticRenderFns } from "./RcvN_Total.vue?vue&type=template&id=1c3cd406"
import script from "./RcvN_Total.vue?vue&type=script&lang=js"
export * from "./RcvN_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports